'use client'

import { createContext, useContext } from 'react'

export const LanguageProviderContext = createContext<string | null>(null)

export const useLanguage = (): string => {
  const context = useContext(LanguageProviderContext)

  if (!context) {
    throw new Error('usePeer must be used within a PeerjsProvider')
  }

  return context
}

export default function LanguageProvider({ children, lang }: { children: React.ReactNode; lang: string }) {
  return <LanguageProviderContext.Provider value={lang}>{children}</LanguageProviderContext.Provider>
}
